<template>
  <div class="interview-filters is-pulled-right">
    <button
      v-if="$can('practice:delete|practice:manage')"
      class="button is-default is-small is-pulled-right ml1"
      @click="$emit('clone')"
      title="Clone"
    >
      <i v-if="!cloneLoading" class="fa fa-copy"></i>
      <i v-if="cloneLoading" class="fa fa-refresh fa-spin"></i>
    </button>

    <a
      v-if="canEdit"
      :href="previewUrl()"
      target="_blank"
      class="button is-default is-small is-pulled-right ml1"
      title="Preview"
    >
      <i class="fa fa-eye"></i>
    </a>

    <div v-if="!canEdit" class="edit-buttons">
      <span>Published: {{ published }}</span>
      <button
        :class="['button', 'is-info', 'is-small', { 'is-loading': loading }]"
        @click="$emit('edit')"
      >
        Edit
      </button>
    </div>
    <div v-if="canEdit" class="edit-buttons">
      <button
        v-if="showPublishButton"
        :class="['button', 'is-primary', 'is-small', { 'is-loading': loading }]"
        @click="$emit('publish')"
      >
        Publish
      </button>
      <button class="button is-small" @click="$emit('cancel')">Cancel</button>
    </div>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "interview-buttons",

  props: [
    "published",
    "onClone",
    "onEdit",
    "onPublish",
    "onCancelEdit",
    "cloneLoading",
    "loading",
    "canEdit",
    "showPublishButton"
  ],

  methods: {
    previewUrl() {
      return InterviewsService.previewUrl(this.$route.params.id);
    }
  }
};
</script>

<style lang="scss" scoped></style>
